"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1026],{

/***/ 952479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 791026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DisclaimerWidget_DisclaimerWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/sessionDisclaimerKey.js


function setSessionDisclaimerKey(value) {
    if (!checkRenderEnv/* IS_SERVER */.W6) sessionStorage.setItem(constants/* SESSION_STORAGE_KEY_NAMES.DISCLAIMER */.zY.DISCLAIMER, value);
}
function getSessionDisclaimerKey() {
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        if (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(constants/* SESSION_STORAGE_KEY_NAMES.DISCLAIMER */.zY.DISCLAIMER)) return sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(constants/* SESSION_STORAGE_KEY_NAMES.DISCLAIMER */.zY.DISCLAIMER);
        return false;
    }
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(952479);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DisclaimerWidget/DisclaimerWidget.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 18px;\n  color: #008fff;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 20px;\n  font-size: 14px;\n  white-space: pre-line;\n  overflow-y: auto;\n  max-height: 60vh;\n  @media screen and (max-width: 767px) {\n    overflow-y: auto;\n    max-height: 50vh;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display : flex;\n  width: 20px;\n  height: 20px;\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  font-size: 12px;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 30px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: red;\n  margin-bottom: 10px;\n  font-size: 12px;\n  visibility: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var DisclaimerWidgetContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetContainer",
    componentId: "sc-939e308d-0"
})(_templateObject());
var DisclaimerWidgetHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetHeading",
    componentId: "sc-939e308d-1"
})(_templateObject1());
var DisclaimerWidgetText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetText",
    componentId: "sc-939e308d-2"
})(_templateObject2());
var DisclaimerWidgetCheckbox = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "DisclaimerWidgetCheckbox",
    componentId: "sc-939e308d-3"
})(_templateObject3());
var DisclaimerWidgetCheckboxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetCheckboxContainer",
    componentId: "sc-939e308d-4"
})(_templateObject4());
var DisclaimerWidgetCtaCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetCtaCheckbox",
    componentId: "sc-939e308d-5"
})(_templateObject5());
var DisclaimerWidgetHeaderTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetHeaderTextContainer",
    componentId: "sc-939e308d-6"
})(_templateObject6());
var DisclaimerWidgetErrorText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DisclaimerWidgetErrorText",
    componentId: "sc-939e308d-7"
})(_templateObject7(), function(props) {
    return props.showErrorMessage ? "visible" : "hidden";
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DisclaimerWidget/DisclaimerWidget.js








function DisclaimerWidget(props) {
    var renderErrorMessage = function renderErrorMessage() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidgetErrorText, {
            showErrorMessage: showErrorMessage,
            children: "Please Accept the above"
        });
    };
    var handleProceed = function handleProceed() {
        var checkBox = document.getElementById("DisclaimerWidgetCheckbox");
        if (checkBox.checked === true) {
            setSessionDisclaimerKey(true);
            setTriggerRerender(!triggerRerender);
        } else {
            setShowErrorMessage(true);
        }
    };
    var handleCheckbox = function handleCheckbox() {
        var checkBox = document.getElementById("DisclaimerWidgetCheckbox");
        if (checkBox.checked === true) {
            setShowErrorMessage(false);
        }
    };
    var isVisible = function isVisible() {
        var ref;
        if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.theme_page) === "true") return false;
        else return !getSessionDisclaimerKey();
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), showErrorMessage = ref3[0], setShowErrorMessage = ref3[1];
    var ref4 = (0,react.useState)(false), triggerRerender = ref4[0], setTriggerRerender = ref4[1];
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: isVisible(),
        className: "bottom-modal",
        animation: "center",
        height: 200,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWidgetContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWidgetHeaderTextContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidgetHeading, {
                            children: (ref = props.config) === null || ref === void 0 ? void 0 : ref.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidgetText, {
                            children: (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.body_text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWidgetCtaCheckbox, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWidgetCheckboxContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidgetCheckbox, {
                                    type: "checkbox",
                                    id: "DisclaimerWidgetCheckbox",
                                    onClick: handleCheckbox
                                }),
                                "\xa0\xa0I agree to the following condition"
                            ]
                        }),
                        renderErrorMessage(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            label: (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.button_text,
                            px: "20px",
                            py: "10px",
                            hoverEnabled: true,
                            fontColor: "#008FFF",
                            backgroundColor: "#FFFFFF",
                            borderColor: "#000000",
                            onClick: handleProceed
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var DisclaimerWidget_DisclaimerWidget = (DisclaimerWidget);


/***/ })

}]);